import { ReactNode } from "react";
import { getFirefoxCssFix } from "../commonfunctions/getFirefoxCssFix";

type AddModelProps = {
  children?: ReactNode; // Optional children prop
  noScroll?: boolean;
  ModelHight?: string;
}
export default function AddModel({ children, noScroll, ModelHight }: AddModelProps) {
  return (
    <div className={`bg-white mt-1 py-2 pl-3 sm:pl-6 pr-2 sm:pr-0 rounded-lg ${ModelHight ? ModelHight : 'h-addsreenheight'}`}>
      <div
        className={`h-full overflow-x-hidden ${!noScroll ? `${getFirefoxCssFix('scroll')} overflow-auto` : 'overflow-hidden'} add-model-scroll-container`}
      >
        {children}
      </div>
    </div>
  )
}
